import { PortalLang, PortalLangISO } from "portal-languages";

type PortalLanguageObj = {
  code: PortalLang;
  name: string;
  iso: PortalLangISO;
  flag: string;
}

export const PORTAL_LANGUAGES_EXT: PortalLanguageObj[] = [
  {code: 'en', name: $localize`English`, iso: 'en-US', flag: 'us' },
  {code: 'it', name: $localize`Italian`, iso: 'it-IT', flag: 'it' },
  {code: 'de', name: $localize`German`, iso: 'de-DE', flag: 'de' },
  {code: 'fr', name: $localize`French`, iso: 'fr-FR', flag: 'fr' },
  {code: 'es', name: $localize`Spanish`, iso: 'es-ES', flag: 'es' },
  {code: 'ru', name: $localize`Russian`, iso: 'ru-RU', flag: 'ru' },
]
